module.exports = __webpack_public_path__ + "static/banner2_mobile-971409ad74d676358a9b08aa1a7e818c.jpg";